import { createReducer } from '@reduxjs/toolkit';
import {
  GETTING_UPLOADS,
  GETTING_UPLOADS_SUCCEEDED,
  GETTING_UPLOADS_FAILED,
  GETTING_USAGE_TYPE_TAGS,
  GETTING_USAGE_TYPE_TAGS_SUCCEEDED,
  GETTING_USAGE_TYPE_TAGS_FAILED,
  CREATING_UPLOAD,
  CREATING_UPLOAD_SUCCEEDED,
  CREATING_UPLOAD_FAILED,
  UPDATING_UPLOAD,
  UPDATING_UPLOAD_SUCCEEDED,
  UPDATING_UPLOAD_FAILED,
  DELETING_UPLOAD,
  DELETING_UPLOAD_SUCCEEDED,
  DELETING_UPLOAD_FAILED,
  UPDATE_UPLOAD_FILTERS,
  RESET_UPLOAD_FILTERS,
  CLEAR_UPLOADS_ERROR,
  CLEAR_UPLOADS_STORE
} from './actions';

const initialFilters = {
  searchInput: '',
  sortBy: '',
  sortOrder: '',
  usageTypeTag: '',
  customTags: [],
  sizeGte: '',
  sizeLte: ''
};

const initialState = {
  getting: false,
  gettingUsageTypeTags: false,
  saving: false,
  deleting: false,
  list: [],
  totalCount: 0,
  usageTypeTags: [],
  error: null,
  filters: initialFilters,
  lastMutationAt: null
};

export default createReducer(initialState, {
  [GETTING_UPLOADS]: state => {
    state.getting = true;
    state.error = null;
  },
  [GETTING_UPLOADS_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.list = action.payload?.data || [];
    state.totalCount = action.payload?.totalCount || 0;
    state.error = null;
  },
  [GETTING_UPLOADS_FAILED]: (state, action) => {
    state.getting = false;
    state.error = action.payload || 'Failed to fetch uploads';
  },
  [GETTING_USAGE_TYPE_TAGS]: state => {
    state.gettingUsageTypeTags = true;
  },
  [GETTING_USAGE_TYPE_TAGS_SUCCEEDED]: (state, action) => {
    state.gettingUsageTypeTags = false;
    state.usageTypeTags = action.payload || [];
  },
  [GETTING_USAGE_TYPE_TAGS_FAILED]: (state, action) => {
    state.gettingUsageTypeTags = false;
    state.error = action.payload || 'Failed to load usage type tags';
  },
  [CREATING_UPLOAD]: state => {
    state.saving = true;
    state.error = null;
  },
  [CREATING_UPLOAD_SUCCEEDED]: state => {
    state.saving = false;
    state.lastMutationAt = Date.now();
  },
  [CREATING_UPLOAD_FAILED]: (state, action) => {
    state.saving = false;
    state.error = action.payload || 'Failed to upload asset';
  },
  [UPDATING_UPLOAD]: state => {
    state.saving = true;
    state.error = null;
  },
  [UPDATING_UPLOAD_SUCCEEDED]: state => {
    state.saving = false;
    state.lastMutationAt = Date.now();
  },
  [UPDATING_UPLOAD_FAILED]: (state, action) => {
    state.saving = false;
    state.error = action.payload || 'Failed to update asset';
  },
  [DELETING_UPLOAD]: state => {
    state.deleting = true;
    state.error = null;
  },
  [DELETING_UPLOAD_SUCCEEDED]: state => {
    state.deleting = false;
    state.lastMutationAt = Date.now();
  },
  [DELETING_UPLOAD_FAILED]: (state, action) => {
    state.deleting = false;
    state.error = action.payload || 'Failed to delete asset';
  },
  [UPDATE_UPLOAD_FILTERS]: (state, action) => {
    state.filters = {
      ...state.filters,
      ...action.payload
    };
  },
  [RESET_UPLOAD_FILTERS]: state => {
    state.filters = initialFilters;
  },
  [CLEAR_UPLOADS_ERROR]: state => {
    state.error = null;
  },
  [CLEAR_UPLOADS_STORE]: () => initialState
});